import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for Team Members - staggered fade in with rotation and scale
 */
export const animateTeamMembers = (ref) => {
  if (ref.current) {
    // Set initial state immediately to prevent flash
    const cards = ref.current.querySelectorAll('[class*="teamCard"]');
    if (cards.length > 0) {
      gsap.set(cards, { opacity: 0, scale: 0.85, rotation: -8, y: 50 });
    }
    
    const timer = setTimeout(() => {
      if (cards.length > 0) {
        gsap.to(cards, {
          opacity: 1,
          scale: 1,
          rotation: 0,
          y: 0,
          duration: 1,
          stagger: 0.2,
          ease: "back.out(1.5)",
          scrollTrigger: {
            trigger: ref.current,
            start: "top 80%",
            toggleActions: "play none none none",
            once: true,
          },
        });
        ScrollTrigger.refresh();
      }
    }, 100);
    
    return () => clearTimeout(timer);
  }
};

